import React, {Component, ReactElement, ReactNode} from 'react'
import {AdminPagePropsSet, createAdminPage} from '../../../components/shared/hoc/createAdminPage'
import EventEmitterExAdmin from '../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {SortOrder} from '../../../components/shared/SortOrder'
import NatClosedSettingRepo, {SearchCondition} from './repository/NatClosedSettingRepo'
import {
    ClosedSettingInfo,
    FacilityClosedSettingInfo,
    NatGetClosedSetting,
    SearchConditionPageInfo,
    SearchResult,
} from './repository/NatGetClosedSetting'
import {
    ClosedPeriod,
    DeleteClosedSetting,
    NatPostClosedSetting,
    NatPostClosedSettingParams,
    RegisterClosedSetting,
    ReservationsByClosedPeriod,
    UpdateClosedSetting,
} from './repository/NatPostClosedSetting'
import {COMMON_CONSTANTS} from '../../../CommonConstants'
import {Nullable} from '../../../app/TypeHelpers'
import {Messages} from '../../../Messages'
import {
    PageFooterArea,
    PageFotterAreaLeft,
    PageFotterAreaRight,
    PageMainArea,
} from '../../../components/shared/hoc/withAdminPageTemplate'
import SortableTableHeader, {
    SortableTableHeaderCell
} from '../../../styledComponents/adminPage/SortablePaginationTableHeader'
import SortablePaginationTable from '../../../styledComponents/adminPage/SortablePaginationTable'
import SortablePaginationTableBody from '../../../styledComponents/adminPage/SortablePaginationTableBody'
import {SortDirection} from '@mui/material/TableCell';
import {
    formatDateTimeForUpdateDate,
    formatDateTimeZeroPadding,
    formatForDateInput,
    formatForHourInput,
    formatForMinutesInput,
} from '../../../formatters/formatDate'
import PPDatePicker from '../../../components/shared/forms/PPDatePicker'
import {HKConstants} from '../../../HKConstants'
import {LeftRowFlexContainer, RightRowFlexContainer, RowFlexContainer} from '../../../styledComponents/FlexComponents'
import PPSelect from '../../../components/shared/forms/PPSelect'
import {addEmptyData} from '../../../componentHelper/selectHelper'
import {HOURS, HOURS_24, MESSAGE_TYPE, RESERVATION_TIME_UNIT_MINUTES} from '../../../CodeMaster'
import {AdminDefaultButton, AdminPrimaryButton} from '../../../styledComponents/adminPage/Buttons'
import {BackLink, DeleteLink} from '../../../styledComponents/adminPage/Links'
import {judgeAuthorityCheck} from '../../common/util/Natutil'
import {HeadingAreaMessageParams} from '../../../components/shared/pageBaseComponents/HeadingAreaMessageComponent'
import PPTextField from '../../../components/shared/forms/PPTextField'
import {
    Box,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    TableBodyProps,
    TableCell,
    TableRow,
} from '@mui/material';
import {createIconWithLevel} from '../../../styledComponents/adminPage/IconCreator'
import NatFacilityReserveRepo from '../facilityReserve/repository/NatFacilityReserveRepo'
import CancelReservationsForm from './CancelReservationsForm'
import {StyledDiv, StyledLabel, StyledP, StyledSpan} from '../../../styledComponents/StyledTypeDefinitions'
import styled from 'styled-components'
import {fromDateAndTimeToMoment} from '../../../dateHelpers/MomentHelper'
import NatCurrentDateTimeRepo from '../currentDateTime/repository/NatCurrentDateTimeRepo'
import {NatGetCurrentDateTime} from '../currentDateTime/repository/NatGetCurrentDateTime'
import moment, {Moment} from 'moment'
import {formatDateLocal, formatDateTimeLocal} from '../../../formatters/formatMoment'
import {isIE} from 'react-device-detect'
import {SessionStorageHelper} from '../../../SessionStorageHelper'
import {convertToMoment} from '../../../components/reservations/helpers/helpers'
import {PersonalInfoExtractHistoryRepo} from '../../../components/PersonalInfoExtractHistoryRepo'
import {SelectChangeEvent} from '@mui/material/Select'
import {Location} from 'react-router-dom'

interface Props {
    currentDateTimeRepo: NatCurrentDateTimeRepo,
    closedSettingRepo: NatClosedSettingRepo,
    facilityReserveRepo: NatFacilityReserveRepo,
    personalInfoExtractHistoryRepo: PersonalInfoExtractHistoryRepo,
    eventEmitter: EventEmitterExAdmin
    location: Location
}

interface States {
    selectedCategoryId: string
    facilityClosedSettingInfo: CustomFacilityClosedSettingInfo[]
    closedSettingSearchResult: SearchResult
    searchCondition: SearchCondition
    searchConditionPageInfo: SearchConditionPageInfo
    searchConditionSortInfo: SortOrder[]
    isLoadCompleted: boolean
    deleteClosedSetting: DeleteClosedSetting[]
    registerCancel: boolean
    registerCompleteType: Nullable<CompleteType>
    dialogStatus: Nullable<DialogContentType>
    currentDateTime: Nullable<Moment>
    closedPeriods: Nullable<ClosedPeriod[]>
    closedSettingParam: Nullable<NatPostClosedSettingParams>
}

interface CustomFacilityClosedSettingInfo extends FacilityClosedSettingInfo {
    closedSettingFlg: boolean
    closedSettingInfo: CustomClosedSettingInfo[]
}

interface CustomClosedSettingInfo extends ClosedSettingInfo {
    formatStartDate: string
    startTimeHour: string
    startTimeMinute: string
    formatEndDate: string
    endTimeHour: string,
    endTimeMinute: string,
    type: Process
}

type Field =
    'startDate'
    | 'startTimeHour'
    | 'startTimeMinute'
    | 'endDate'
    | 'endTimeHour'
    | 'endTimeMinute'
    | 'closedReason'

type Process =
    'register'
    | 'update'

type CompleteType =
    'registerClosedSettings'
    | 'cancelReservations'

type DialogContentType = 'registerCloseSettings' | 'cancelReservations'

class NatAdminClosedSettingPage extends Component<Props & AdminPagePropsSet, States> {
    // 初期表示時の休館設定保持用
    originFacilityClosedSettingInfo: CustomFacilityClosedSettingInfo[]
    // ソートのサブキー用
    subSortKey: SortOrder = new SortOrder('facilityId', 'asc')

    constructor(props: Props & AdminPagePropsSet) {
        super(props)

        let registerCancel: boolean = false
        if (
            this.props.location &&
            this.props.location.state &&
            this.props.location.state.registerCancel
        ) {

            registerCancel = true
            this.props.navigate(this.props.location.pathname, {
                state: {
                    registerCancel: false,
                },
            })
        }
        let registerCompleteType: Nullable<CompleteType> = null
        if (
            this.props.location &&
            this.props.location.state &&
            this.props.location.state.registerCompleteType !== null
        ) {

            registerCompleteType = this.props.location.state.registerCompleteType
            this.props.navigate(this.props.location.pathname, {
                state: {
                    registerCompleteType: null,
                },
            })
        }
        this.state = {
            selectedCategoryId: '',
            facilityClosedSettingInfo: [],
            closedSettingSearchResult: {},
            searchCondition: {
                getNoClosedSettingFacilityFlag: (
                    judgeAuthorityCheck(HKConstants.CMN.AUTH.EDIT_FACILITY_CLOSED_SETTING) ? '1' : '0'),
            },
            searchConditionPageInfo: {
                pageNum: COMMON_CONSTANTS.ROWS_PER_PAGE_SETTINGS[0],
                page: COMMON_CONSTANTS.FIRST_PAGE,
            },
            searchConditionSortInfo: [
                new SortOrder('updateDatetime', 'desc'),
                new SortOrder('sortOrder', 'asc'),
            ],
            isLoadCompleted: false,
            deleteClosedSetting: [],
            registerCancel: registerCancel,
            registerCompleteType: registerCompleteType,
            dialogStatus: null,
            currentDateTime: null,
            closedPeriods: null,
            closedSettingParam: null,
        }

        this.originFacilityClosedSettingInfo = []
        this.addClosedSetting = this.addClosedSetting.bind(this)
        this.changeClosedReason = this.changeClosedReason.bind(this)
        this.deleteClosedSettingRegisterLinkClick = this.deleteClosedSettingRegisterLinkClick.bind(this)
        this.changeStartDate = this.changeStartDate.bind(this)
        this.changeStartTimeHour = this.changeStartTimeHour.bind(this)
        this.changeStartTimeMinute = this.changeStartTimeMinute.bind(this)
        this.changeEndDate = this.changeEndDate.bind(this)
        this.changeEndTimeHour = this.changeEndTimeHour.bind(this)
        this.changeEndTimeMinute = this.changeEndTimeMinute.bind(this)
        this.registerClosedSettingButton = this.registerClosedSettingButton.bind(this)
        this.handleChangePage = this.handleChangePage.bind(this)
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this)
        this.handleSortClosedSettings = this.handleSortClosedSettings.bind(this)
        this.handleDeleteCancelClick = this.handleDeleteCancelClick.bind(this)
        this.handleDeleteOkClick = this.handleDeleteOkClick.bind(this)
        this.handleRegisterCancelClick = this.handleRegisterCancelClick.bind(this)
        this.handleRegisterOkClick = this.handleRegisterOkClick.bind(this)
        this.deleteClosedSettingUpdateLinkClick = this.deleteClosedSettingUpdateLinkClick.bind(this)
        this.handleOkClickDialogForRegisterClosedSettings = this.handleOkClickDialogForRegisterClosedSettings.bind(this)
        this.handleCancelClickDialogForRegisterClosedSettings =
            this.handleCancelClickDialogForRegisterClosedSettings.bind(this)
        this.handleOkClickDialogForCancelReservations = this.handleOkClickDialogForCancelReservations.bind(this)
        this.handleCloseClickDialogForCancelReservations = this.handleCloseClickDialogForCancelReservations.bind(this)
        this.handleDownloadCSV = this.handleDownloadCSV.bind(this)
        this.changePage = this.changePage.bind(this)
        this.changeRowsPer = this.changeRowsPer.bind(this)
        this.changeSort = this.changeSort.bind(this)

    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            // 休館設定取得
            await this.getClosedSetting(
                this.state.searchCondition,
                this.state.searchConditionPageInfo,
                this.state.searchConditionSortInfo,
            )
            this.showInitialMessage()
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    showInitialMessage(): void {
        if (!this.props.location || !this.props.location.state) {
            return
        } else if (this.state.registerCancel) {
            this.setState({registerCancel: false})
            const registerCancelMessage: HeadingAreaMessageParams = {
                title: null,
                messageLevel: MESSAGE_TYPE.INFORMATION,
                detail: Messages.IOPCC0013.toString(''),
            }
            this.props.eventEmitter.showHeadingAreaMessage(registerCancelMessage)
            return
        } else if (this.state.registerCompleteType === 'registerClosedSettings') {
            this.setState({registerCompleteType: null})
            const registerCompleteMessage: HeadingAreaMessageParams = {
                title: null,
                messageLevel: MESSAGE_TYPE.INFORMATION,
                detail: Messages.IOPCC0008.toString('休館設定'),
            }
            this.props.eventEmitter.showHeadingAreaMessage(registerCompleteMessage)
            return
        } else if (this.state.registerCompleteType === 'cancelReservations') {
            this.setState({registerCompleteType: null})
            const registerCompleteMessage: HeadingAreaMessageParams = {
                title: null,
                messageLevel: MESSAGE_TYPE.INFORMATION,
                detail: Messages.IOPCC0008.toString('休館設定') +
                    Messages.IFACA0036.toString(),
            }
            this.props.eventEmitter.showHeadingAreaMessage(registerCompleteMessage)
            return
        }

        const initialMessage: HeadingAreaMessageParams = this.props.location.state.initialMessage
        this.props.navigate(this.props.location.pathname, {replace: true})
        this.props.eventEmitter.showHeadingAreaMessage(initialMessage)
    }

    async getClosedSetting(
        searchCondition: SearchCondition,
        searchConditionPageInfo: SearchConditionPageInfo,
        searchConditionSortInfos: SortOrder[],
    ): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            const closedSettingResponse: Nullable<NatGetClosedSetting> = await this.props.asyncCallFunction(
                this.props.closedSettingRepo.getClosedSetting.bind(
                    this.props.closedSettingRepo,
                    searchCondition,
                    searchConditionPageInfo,
                    [...searchConditionSortInfos, this.subSortKey]),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )

            if (closedSettingResponse && closedSettingResponse.details) {
                // 取得結果を加工
                const customFacilityClosedSettingInfo: CustomFacilityClosedSettingInfo[] = []
                if (closedSettingResponse.details.facilityClosedSettingInfo) {
                    closedSettingResponse.details.facilityClosedSettingInfo.forEach((facilityId) => {
                        const customFacilityClosedSetting: CustomFacilityClosedSettingInfo = {
                            ...facilityId,
                            closedSettingFlg: (facilityId.closedSettingInfo !== null),
                            closedSettingInfo: [],
                        }
                        const closedSettingInfo: ClosedSettingInfo[] = facilityId.closedSettingInfo
                        if (closedSettingInfo.length > 0) {
                            // 既に休館設定が登録されている場合
                            closedSettingInfo.forEach((seq) => {
                                // 更新用のフォーム格納
                                const customClosedSettingInfo: CustomClosedSettingInfo = {
                                    ...seq,
                                    formatStartDate: formatDateTimeZeroPadding(seq.startDate),
                                    startDate: new Date(formatForDateInput(seq.startDate)).toString(),
                                    startTimeHour: formatForHourInput(seq.startDate),
                                    startTimeMinute: formatForMinutesInput(seq.startDate),
                                    formatEndDate: formatDateTimeZeroPadding(seq.endDate),
                                    endDate: new Date(formatForDateInput(seq.endDate)).toString(),
                                    endTimeHour: formatForHourInput(seq.endDate),
                                    endTimeMinute: formatForMinutesInput(seq.endDate),
                                    type: 'update',
                                }
                                customFacilityClosedSetting.closedSettingInfo.push(customClosedSettingInfo)
                            })
                        } else {
                            // 休館設定が登録されていない場合、登録用のフォーム格納
                            const customClosedSettingInfo: CustomClosedSettingInfo = {
                                seq: 1,
                                formatStartDate: '',
                                startDate: '',
                                startTimeHour: '',
                                startTimeMinute: '',
                                formatEndDate: '',
                                endTimeHour: '',
                                endTimeMinute: '',
                                endDate: '',
                                closedReason: '',
                                type: 'register',
                            }
                            customFacilityClosedSetting.closedSettingInfo.push(customClosedSettingInfo)
                        }
                        customFacilityClosedSettingInfo.push(customFacilityClosedSetting)
                    })
                }

                this.originFacilityClosedSettingInfo = JSON.parse(JSON.stringify(customFacilityClosedSettingInfo))

                this.setState({
                    facilityClosedSettingInfo: customFacilityClosedSettingInfo,
                    closedSettingSearchResult: closedSettingResponse.details.searchResult,
                    isLoadCompleted: true,
                })
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    // 休館設定追加
    addClosedSetting(facilityId: string): void {
        const facilityClosedSettingInfo: CustomFacilityClosedSettingInfo[] = this.state.facilityClosedSettingInfo
        facilityClosedSettingInfo.some((closedSetting, key) => {
            // 対象の施設に、休館設定を追加
            if (closedSetting.facilityId === facilityId) {
                const closedSettingInfo: CustomClosedSettingInfo[] =
                    JSON.parse(JSON.stringify(facilityClosedSettingInfo[key].closedSettingInfo))
                closedSettingInfo.sort((a, b) => Number(b.seq) - Number(a.seq))

                const addClosedSetting: CustomClosedSettingInfo = {
                    seq: closedSettingInfo[0].seq + 1,
                    formatStartDate: '',
                    startDate: '',
                    startTimeHour: '',
                    startTimeMinute: '',
                    formatEndDate: '',
                    endTimeHour: '',
                    endTimeMinute: '',
                    endDate: '',
                    closedReason: '',
                    type: 'register',
                }
                facilityClosedSettingInfo[key].closedSettingInfo.push(addClosedSetting)
                this.setState({facilityClosedSettingInfo: facilityClosedSettingInfo})
                return true
            }
        })
    }

    renderClosedSettingTable(closedSettingList: FacilityClosedSettingInfo[]): Nullable<ReactElement> {
        if (closedSettingList.length === 0) {
            return null
        }

        let headers: SortableTableHeaderCell[]

        if (judgeAuthorityCheck(HKConstants.CMN.AUTH.EDIT_FACILITY_CLOSED_SETTING)) {
            headers = [
                {id: 'facilityName', label: '施設名'},
                {id: 'categoryName', label: 'カテゴリ'},
                {
                    id: 'updateDatetime',
                    label: '更新日時',
                    sortable: true,
                    direction: this.getSortDirection('updateDatetime'),
                },
                {id: 'closedSetting', label: '休館設定'},
                {id: 'action', label: '操作'},
            ]
        } else {
            headers = [
                {id: 'facilityName', label: '施設名'},
                {id: 'categoryName', label: 'カテゴリ'},
                {
                    id: 'updateDatetime',
                    label: '更新日時',
                    sortable: true,
                    direction: this.getSortDirection('updateDatetime'),
                },
                {id: 'closedSetting', label: '休館設定'},
            ]
        }

        return (
            <SortablePaginationTable
                paginationProps={{
                    count: this.state.closedSettingSearchResult.total ? this.state.closedSettingSearchResult.total : 0,
                    rowsPerPage:
                        this.state.searchConditionPageInfo.pageNum ? this.state.searchConditionPageInfo.pageNum : 0,
                    page: this.state.searchConditionPageInfo.page ? this.state.searchConditionPageInfo.page : 0,
                    onPageChange: this.handleChangePage,
                    onRowsPerPageChange: this.handleChangeRowsPerPage,
                }}
            >
                <SortableTableHeader
                    noWrap
                    headers={headers}
                    onSortOrderChange={this.handleSortClosedSettings}
                />
                <StyledSortablePaginationTableBody
                    viewFlg={(!judgeAuthorityCheck(HKConstants.CMN.AUTH.EDIT_FACILITY_CLOSED_SETTING) &&
                        judgeAuthorityCheck(HKConstants.CMN.AUTH.VIEW_FACILITY_CLOSED_SETTING))}>
                    {this.state.facilityClosedSettingInfo.map((facilityClosedSettingInfo) => (
                        this.renderClosedSettingRecord(facilityClosedSettingInfo)
                    ))}
                </StyledSortablePaginationTableBody>
            </SortablePaginationTable>
        )
    }

    getSortDirection(sortKey: string): SortDirection {
        const sortOrder: SortOrder | undefined =
            this.state.searchConditionSortInfo.find(order => order.sortKey === sortKey)
        if (sortOrder === undefined) {
            return false
        }
        return sortOrder.sortDirection
    }

    async handleChangePage(
        event: React.MouseEvent<HTMLButtonElement, MouseEvent> | null,
        newPage: number,
    ): Promise<void> {
        this.beforeUserAction()
        await this.props.eventEmitter.showDialog({
                title: '確認',
                errorLevel: Messages.WOPCC0001.errorLevel,
                message: Messages.WOPCC0001.toString(),
                buttonProps: [
                    {
                        isDefault: false,
                        buttonLabel: 'キャンセル',
                        buttonHandler: () => this.props.eventEmitter.closeDialog(),
                    },
                    {
                        isDefault: false,
                        buttonLabel: 'OK',
                        buttonHandler: () => this.changePage(event, newPage),
                    },
                ],
            },
        )
    }

    async changePage(
        event: React.MouseEvent<HTMLButtonElement, MouseEvent> | null,
        newPage: number,
    ): Promise<void> {
        this.props.eventEmitter.closeDialog()
        const searchConditionPageInfo: SearchConditionPageInfo = this.state.searchConditionPageInfo
        searchConditionPageInfo.page = newPage
        await this.getClosedSetting(
            this.state.searchCondition,
            searchConditionPageInfo,
            this.state.searchConditionSortInfo,
        )
        this.setState({
            searchConditionPageInfo: searchConditionPageInfo,
            deleteClosedSetting: [],
        })
    }

    beforeUserAction(): void {
        this.props.eventEmitter.clearHeadingAreaMessage()
    }

    async handleChangeRowsPerPage(event: React.ChangeEvent<HTMLInputElement>): Promise<void> {
        this.beforeUserAction()
        await this.props.eventEmitter.showDialog({
                title: '確認',
                errorLevel: Messages.WOPCC0001.errorLevel,
                message: Messages.WOPCC0001.toString(),
                buttonProps: [
                    {
                        isDefault: false,
                        buttonLabel: 'キャンセル',
                        buttonHandler: () => this.props.eventEmitter.closeDialog(),
                    },
                    {
                        isDefault: false,
                        buttonLabel: 'OK',
                        buttonHandler: () => {
                            this.changeRowsPer(event)
                        },
                    },
                ],
            },
        )
    }

    async changeRowsPer(event: React.ChangeEvent<HTMLInputElement>): Promise<void> {
        this.props.eventEmitter.closeDialog()
        const searchConditionPageInfo: SearchConditionPageInfo = this.state.searchConditionPageInfo
        searchConditionPageInfo.pageNum = Number(event.target.value)
        searchConditionPageInfo.page = COMMON_CONSTANTS.FIRST_PAGE
        await this.getClosedSetting(
            this.state.searchCondition,
            searchConditionPageInfo,
            this.state.searchConditionSortInfo,
        )
        this.setState({
            searchConditionPageInfo: searchConditionPageInfo,
            deleteClosedSetting: [],
        })
    }

    async handleSortClosedSettings(sortKey: string): Promise<void> {
        this.beforeUserAction()
        await this.props.eventEmitter.showDialog({
                title: '確認',
                errorLevel: Messages.WOPCC0001.errorLevel,
                message: Messages.WOPCC0001.toString(),
                buttonProps: [
                    {
                        isDefault: false,
                        buttonLabel: 'キャンセル',
                        buttonHandler: () => this.props.eventEmitter.closeDialog(),
                    },
                    {
                        isDefault: false,
                        buttonLabel: 'OK',
                        buttonHandler: () => this.changeSort(sortKey),
                    },
                ],
            },
        )
    }

    async changeSort(sortKey: string): Promise<void> {
        this.props.eventEmitter.closeDialog()

        let sortDirection: SortDirection = this.getSortDirection(sortKey)
        if (sortDirection === false || sortDirection === 'desc') {
            sortDirection = 'asc'
        } else {
            sortDirection = 'desc'
        }

        const sortOrders: SortOrder[] = [new SortOrder(sortKey, sortDirection)]
        await this.getClosedSetting(
            this.state.searchCondition,
            this.state.searchConditionPageInfo,
            sortOrders,
        )
        this.setState({
            searchConditionSortInfo: sortOrders,
            deleteClosedSetting: [],
        })
    }

    renderClosedSettingRecord(facilityClosedSettingInfo: CustomFacilityClosedSettingInfo): ReactElement {
        return (
            <TableRow key={facilityClosedSettingInfo.facilityId}>
                <FacilityTableCell align={'center'}>{facilityClosedSettingInfo.facilityName}</FacilityTableCell>
                {
                    (judgeAuthorityCheck(HKConstants.CMN.AUTH.EDIT_FACILITY_CLOSED_SETTING)) ?
                        <TableCell align={'center'} style={{width: '10%'}}>
                            {facilityClosedSettingInfo.categoryName}
                        </TableCell> :
                        <TableCell align={'center'}>{
                            facilityClosedSettingInfo.categoryName}
                        </TableCell>
                }
                {
                    (judgeAuthorityCheck(HKConstants.CMN.AUTH.EDIT_FACILITY_CLOSED_SETTING)) ?
                        <TableCell align={'center'} style={{width: '10%'}}>
                            {formatDateTimeForUpdateDate(facilityClosedSettingInfo.updateDatetime)}
                        </TableCell> :
                        <TableCell
                            align={'center'}>
                            {formatDateTimeForUpdateDate(facilityClosedSettingInfo.updateDatetime)}
                        </TableCell>
                }
                <StyledTableCell align={'center'}>
                    {(judgeAuthorityCheck(HKConstants.CMN.AUTH.EDIT_FACILITY_CLOSED_SETTING)) ?
                        this.preClosedSetting(
                            facilityClosedSettingInfo.closedSettingInfo,
                            facilityClosedSettingInfo.closedSettingFlg,
                            facilityClosedSettingInfo.facilityId,
                            facilityClosedSettingInfo.facilityName,
                        ) :
                        this.renderClosedSettingInfoEditView(
                            facilityClosedSettingInfo.closedSettingInfo,
                            facilityClosedSettingInfo.facilityId,
                        )}
                </StyledTableCell>
                {
                    (judgeAuthorityCheck(HKConstants.CMN.AUTH.EDIT_FACILITY_CLOSED_SETTING)) ?
                        <TableCell style={{width: '10%'}}>
                            <AdminDefaultButton
                                size={'small'}
                                onClick={() => this.addClosedSetting(facilityClosedSettingInfo.facilityId)}>
                                追加
                            </AdminDefaultButton>
                        </TableCell> : ''
                }
            </TableRow>
        )
    }

    preClosedSetting(
        closedSettingInfo: CustomClosedSettingInfo[],
        closedSettingFlg: boolean,
        facilityId: string,
        facilityName: string,
    ): ReactElement {

        // 施設に対する休館設定数
        const closedSettingCount: number = closedSettingInfo.length
        return (<>
            {
                closedSettingInfo.map((closedSetting, index) => (
                    <Box mb={'30px'} key={`edit_${facilityId}_${index}`}>
                        {this.renderClosedSettingInfoEdit(
                            closedSetting,
                            closedSettingCount,
                            closedSettingFlg,
                            facilityId,
                            facilityName,
                        )}
                    </Box>
                ))}
        </>)
    }

    // 休館設定（編集）
    renderClosedSettingInfoEdit(
        closedSettingInfo: CustomClosedSettingInfo,
        closedSettingCount: number,
        closedSettingFlg: boolean,
        facilityId: string,
        facilityName: string,
    ): ReactElement {

        // 施設/休館設定のインテックス取得
        let facilityIndex: number = 0
        let closedSettingIndex: number = 0
        const facilityClosedSettingInfo: CustomFacilityClosedSettingInfo[] = this.state.facilityClosedSettingInfo
        facilityClosedSettingInfo.some((facility, key) => {
            if (facility.facilityId === facilityId) {
                facilityIndex = key
                facility.closedSettingInfo.some((closedSetting, closedSettingKey) => {
                    if (closedSetting.seq === closedSettingInfo.seq) {
                        closedSettingIndex = closedSettingKey
                        return true
                    }
                })
                return true
            }
        })

        // 施設/休館設定のインテックス取得（origin）
        let originFacilityIndex: number = 0
        let originClosedSettingIndex: number = 0
        const originFacilityClosedSettingInfo: CustomFacilityClosedSettingInfo[] = this.originFacilityClosedSettingInfo
        originFacilityClosedSettingInfo.some((facility, key) => {
            if (facility.facilityId === facilityId) {
                originFacilityIndex = key
                facility.closedSettingInfo.some((closedSetting, closedSettingKey) => {
                    if (closedSetting.seq === closedSettingInfo.seq) {
                        originClosedSettingIndex = closedSettingKey
                        return true
                    }
                })
                return true
            }
        })

        return (
            <LeftRowFlexContainer>
                <TermFlexContainer>
                    <WrapperInputForm
                        key={`${facilityId}-${closedSettingInfo.seq}-startDate`}
                        changeFlg={
                            this.judgeClosedSetting(
                                closedSettingInfo.type,
                                facilityIndex,
                                closedSettingIndex,
                                originFacilityIndex,
                                originClosedSettingIndex,
                                'startDate')
                        }
                    >
                        <FlexBasis style={{paddingBottom: 4, paddingTop: 8}}>
                            <PPDatePicker
                                onChangeDate={this.changeStartDate.bind(this, facilityIndex, closedSettingIndex)}
                                value={
                                    (closedSettingInfo.startDate === '') ? null : new Date(closedSettingInfo.startDate)
                                }
                                maxDate={
                                    (closedSettingInfo.endDate !== '') ? new Date(closedSettingInfo.endDate) : undefined
                                }
                                eventEmitter={this.props.eventEmitter}
                                eventKeys={[`${facilityId}-${closedSettingInfo.seq}-startDate`]}
                            />
                        </FlexBasis>
                    </WrapperInputForm>
                    <RowFlexContainer>
                        <WrapperInputForm
                            changeFlg={
                                this.judgeClosedSetting(
                                    closedSettingInfo.type,
                                    facilityIndex,
                                    closedSettingIndex,
                                    originFacilityIndex,
                                    originClosedSettingIndex,
                                    'startTimeHour')
                            }
                            key={`${facilityId}-${closedSettingInfo.seq}-startTimeHour`}
                        >
                            <PPSelect
                                data={addEmptyData(HOURS.values())}
                                value={closedSettingInfo.startTimeHour}
                                onChange={this.changeStartTimeHour.bind(this, facilityIndex, closedSettingIndex)}
                                eventEmitter={this.props.eventEmitter}
                                eventKeys={[`${facilityId}-${closedSettingInfo.seq}-startTimeHour`]}
                            />
                            <span>時</span>
                        </WrapperInputForm>
                        <WrapperInputForm
                            changeFlg={
                                this.judgeClosedSetting(
                                    closedSettingInfo.type,
                                    facilityIndex,
                                    closedSettingIndex,
                                    originFacilityIndex,
                                    originClosedSettingIndex,
                                    'startTimeMinute')
                            }
                            key={`${facilityId}-${closedSettingInfo.seq}-startTimeMinute`}
                        >
                            <PPSelect
                                data={addEmptyData(RESERVATION_TIME_UNIT_MINUTES.values())}
                                value={closedSettingInfo.startTimeMinute}
                                onChange={this.changeStartTimeMinute.bind(this, facilityIndex, closedSettingIndex)}
                                eventEmitter={this.props.eventEmitter}
                                eventKeys={[`${facilityId}-${closedSettingInfo.seq}-startTimeMinute`]}
                            /><PaddingRightTxt>分</PaddingRightTxt>
                        </WrapperInputForm>
                    </RowFlexContainer>
                </TermFlexContainer>
                <FromToLabel>〜</FromToLabel>
                <TermFlexContainer>
                    <WrapperInputForm
                        key={`${facilityId}-${closedSettingInfo.seq}-endDate`}
                        changeFlg={
                            this.judgeClosedSetting(
                                closedSettingInfo.type,
                                facilityIndex,
                                closedSettingIndex,
                                originFacilityIndex,
                                originClosedSettingIndex,
                                'endDate')
                        }
                    >
                        <FlexBasis style={{paddingBottom: 4, paddingTop: 8}}>
                            <PPDatePicker
                                onChangeDate={this.changeEndDate.bind(this, facilityIndex, closedSettingIndex)}
                                value={
                                    (closedSettingInfo.endDate === '') ? null : new Date(closedSettingInfo.endDate)
                                }
                                minDate={
                                    (closedSettingInfo.startDate !== '') ?
                                        new Date(closedSettingInfo.startDate) : undefined
                                }
                                eventEmitter={this.props.eventEmitter}
                                eventKeys={[`${facilityId}-${closedSettingInfo.seq}-endDate`]}
                            />
                        </FlexBasis>
                    </WrapperInputForm>
                    <RowFlexContainer>
                        <WrapperInputForm
                            changeFlg={
                                this.judgeClosedSetting(
                                    closedSettingInfo.type,
                                    facilityIndex,
                                    closedSettingIndex,
                                    originFacilityIndex,
                                    originClosedSettingIndex,
                                    'endTimeHour')
                            }
                            key={`${facilityId}-${closedSettingInfo.seq}-endTimeHour`}
                        >
                            <PPSelect
                                data={addEmptyData(HOURS_24.values())}
                                value={closedSettingInfo.endTimeHour}
                                onChange={
                                    this.changeEndTimeHour.bind(
                                        this,
                                        facilityIndex,
                                        closedSettingIndex)
                                }
                                eventEmitter={this.props.eventEmitter}
                                eventKeys={[`${facilityId}-${closedSettingInfo.seq}-endTimeHour`]}
                            />
                            <span>時</span>
                        </WrapperInputForm>
                        <WrapperInputForm
                            changeFlg={
                                this.judgeClosedSetting(
                                    closedSettingInfo.type,
                                    facilityIndex,
                                    closedSettingIndex,
                                    originFacilityIndex,
                                    originClosedSettingIndex,
                                    'endTimeMinute')
                            }
                            key={`${facilityId}-${closedSettingInfo.seq}-endTimeMinute`}
                        >
                            <PPSelect
                                data={addEmptyData(RESERVATION_TIME_UNIT_MINUTES.values())}
                                value={closedSettingInfo.endTimeMinute}
                                onChange={this.changeEndTimeMinute.bind(this, facilityIndex, closedSettingIndex)}
                                eventEmitter={this.props.eventEmitter}
                                eventKeys={[`${facilityId}-${closedSettingInfo.seq}-endTimeMinute`]}
                            />
                            <PaddingRightTxt>分</PaddingRightTxt>
                        </WrapperInputForm>
                    </RowFlexContainer>
                </TermFlexContainer>
                <ClosedReasonFlexContainer>
                    <WrapperInputForm
                        changeFlg={
                            this.judgeClosedSetting(
                                closedSettingInfo.type,
                                facilityIndex,
                                closedSettingIndex,
                                originFacilityIndex,
                                originClosedSettingIndex,
                                'closedReason')
                        }
                        key={`${facilityId}-${closedSettingInfo.seq}-closedReason`}
                    >
                        <FlexBasis>
                            <PPTextField
                                InputProps={{
                                    inputProps: {
                                        id: `${facilityId}-${closedSettingInfo.seq}-publishMaterialName`,
                                        maxLength: 20,
                                    },
                                }}
                                fullWidth
                                data-hgoe={'1'}
                                placeholder={'休館理由'}
                                value={closedSettingInfo.closedReason}
                                eventEmitter={this.props.eventEmitter}
                                onChange={this.changeClosedReason.bind(this, facilityIndex, closedSettingIndex)}
                                eventKeys={[`${facilityId}-${closedSettingInfo.seq}-closedReason`]}
                            />
                        </FlexBasis>
                    </WrapperInputForm>
                    {this.renderClosedReason(
                        closedSettingInfo.type,
                        facilityIndex,
                        closedSettingIndex,
                        facilityName,
                        closedSettingCount,
                        closedSettingInfo.seq)}
                </ClosedReasonFlexContainer>
            </LeftRowFlexContainer>
        )
    }

    // 休館設定（参照）
    renderClosedSettingInfoEditView(closedSettingInfo: CustomClosedSettingInfo[], facilityId: string): ReactElement {
        return (<>
            {
                closedSettingInfo.map((closedSetting, index) => (
                    <WrapperViewClosedSetting key={`view_${facilityId}_${index}`}>
                        <ViewClosedSettingText>{closedSetting.formatStartDate} ～ {closedSetting.formatEndDate}<br/>
                            {closedSetting.closedReason}</ViewClosedSettingText>
                    </WrapperViewClosedSetting>
                ))}
        </>)
    }

    // 削除
    renderClosedReason(
        type: 'register' | 'update',
        facilityIndex: number,
        closedSettingIndex: number,
        facilityName: string,
        closedSettingCount: number,
        seq: number,
    ): Nullable<ReactElement> {

        if (type === 'update') {
            // 既に休館設定が登録されている場合
            return (
                <RightRowFlexContainer>
                    <Box mt={'5px'}>
                        <DeleteLink onClick={(event: React.MouseEvent) => {
                            event.preventDefault()
                            this.deleteClosedSettingUpdateLinkClick(
                                seq,
                                facilityIndex,
                                closedSettingIndex,
                                facilityName,
                                closedSettingCount,
                            )
                        }}>
                            削除
                        </DeleteLink>
                    </Box>
                </RightRowFlexContainer>
            )
        } else if (closedSettingCount >= 2) {
            // 休館設定が登録されていない　かつ　2件以上、休館設定入力が追加されている場合
            return (
                <RightRowFlexContainer>
                    <Box mt={'5px'}>
                        <DeleteLink onClick={(event: React.MouseEvent) => {
                            event.preventDefault()
                            this.deleteClosedSettingRegisterLinkClick(
                                seq,
                                facilityIndex,
                            )
                        }}>
                            削除
                        </DeleteLink>
                    </Box>
                </RightRowFlexContainer>
            )
        } else {
            return null
        }
    }

    // 休館設定削除 クリックイベント（休館設定が登録されている）
    async deleteClosedSettingUpdateLinkClick(
        seq: number,
        facilityIndex: number,
        closedSettingIndex: number,
        facilityName: string,
        closedSettingCount: number,
    ): Promise<void> {
        await this.props.eventEmitter.showDialog({
            title: '警告',
            errorLevel: Messages.IOPCC0011.errorLevel,
            message: Messages.IOPCC0011.toString(facilityName + ' 休館設定'),
            buttonProps: [
                {
                    isDefault: false,
                    buttonLabel: 'キャンセル',
                    buttonHandler: this.handleDeleteCancelClick,
                },
                {
                    isDefault: false,
                    buttonLabel: 'OK',
                    buttonHandler: () => this.handleDeleteOkClick(
                        seq,
                        facilityIndex,
                        closedSettingIndex,
                        closedSettingCount),
                },
            ],
        })
    }

    handleDeleteCancelClick(): void {
        this.props.eventEmitter.closeDialog()
    }

    handleDeleteOkClick(
        seq: number,
        facilityIndex: number,
        closedSettingIndex: number,
        closedSettingCount: number,
    ): void {

        const facilityClosedSettingInfo: CustomFacilityClosedSettingInfo[] = this.state.facilityClosedSettingInfo
        const facilityId: string = facilityClosedSettingInfo[facilityIndex].facilityId

        // 休館設定が1件しか存在しない場合、対象要素を空更新
        if (closedSettingCount === 1) {
            facilityClosedSettingInfo[facilityIndex].closedSettingInfo[closedSettingIndex] = {
                seq: 1,
                formatStartDate: '',
                startDate: '',
                startTimeHour: '',
                startTimeMinute: '',
                formatEndDate: '',
                endTimeHour: '',
                endTimeMinute: '',
                endDate: '',
                closedReason: '',
                type: 'register',
            }
        } else {
            // 休館設定が複数件存在している場合、対象要素を削除
            facilityClosedSettingInfo[facilityIndex].closedSettingInfo.splice(closedSettingIndex, 1)
        }

        this.setState(({deleteClosedSetting}) => ({
            facilityClosedSettingInfo: facilityClosedSettingInfo,
            deleteClosedSetting: [
                ...deleteClosedSetting,
                {
                    facilityId: facilityId,
                    seq: seq,
                },
            ],
        }))

        this.props.eventEmitter.closeDialog()
    }

    // 休館設定削除 クリックイベント（休館設定が登録されていない）
    deleteClosedSettingRegisterLinkClick(seq: number, facilityIndex: number): void {
        const facilityClosedSettingInfo: CustomFacilityClosedSettingInfo[] = this.state.facilityClosedSettingInfo
        const tmpClosedSettingInfo: CustomClosedSettingInfo[] = []

        facilityClosedSettingInfo[facilityIndex].closedSettingInfo.some((closedSetting, closedSettingKey) => {
            // 削除対象の休館設定より連番が大きい場合、seqを一つ下げる
            if (closedSetting.seq > seq) {
                tmpClosedSettingInfo.push({
                    ...facilityClosedSettingInfo[facilityIndex].closedSettingInfo[closedSettingKey],
                    seq: facilityClosedSettingInfo[facilityIndex].closedSettingInfo[closedSettingKey].seq - 1,
                })
            } else if (seq > closedSetting.seq) {
                // 削除対象の休館設定より連番が小さい場合、そのままpush
                tmpClosedSettingInfo.push({
                    ...facilityClosedSettingInfo[facilityIndex].closedSettingInfo[closedSettingKey],
                })
            }
        })

        facilityClosedSettingInfo[facilityIndex].closedSettingInfo = tmpClosedSettingInfo
        this.setState({facilityClosedSettingInfo: facilityClosedSettingInfo})
    }

    cancelLinkClick(): void {
        this.props.navigate(this.props.location.pathname, {
            state: {
                registerCancel: true,
                dialogStatus: null,
            },
        })
        window.location.reload()
    }

    changeStartDate(facilityIndex: number, closedSettingFacilityIndex: number, date: Nullable<Date>): void {
        const facilityClosedSettingInfo: CustomFacilityClosedSettingInfo[] = this.state.facilityClosedSettingInfo
        if (date !== null) {
            facilityClosedSettingInfo[facilityIndex].closedSettingInfo[closedSettingFacilityIndex].startDate =
                date.toString()
        } else {
            facilityClosedSettingInfo[facilityIndex].closedSettingInfo[closedSettingFacilityIndex].startDate = ''
        }

        this.setState({facilityClosedSettingInfo: facilityClosedSettingInfo})
    }

    changeStartTimeHour(
        facilityIndex: number,
        closedSettingFacilityIndex: number,
        event: SelectChangeEvent<unknown>,
    ): void {
        let startTimeHour: string = ''
        try {
            const codeMaster = HOURS.codeToEnumConstants(event.target.value as string)
            if (codeMaster) {
                startTimeHour = event.target.value as string
            }
        } catch (e) {
            startTimeHour = ''
        }

        const facilityClosedSettingInfo: CustomFacilityClosedSettingInfo[] = this.state.facilityClosedSettingInfo
        facilityClosedSettingInfo[facilityIndex].closedSettingInfo[closedSettingFacilityIndex].startTimeHour =
            startTimeHour

        this.setState({
            facilityClosedSettingInfo: facilityClosedSettingInfo,
        })
    }

    changeStartTimeMinute(
        facilityIndex: number,
        closedSettingFacilityIndex: number,
        event: SelectChangeEvent<unknown>,
    ): void {
        let startTimeMinute: string = ''
        try {
            const codeMaster = RESERVATION_TIME_UNIT_MINUTES.codeToEnumConstants(event.target.value as string)
            if (codeMaster) {
                startTimeMinute = event.target.value as string
            }
        } catch (e) {
            startTimeMinute = ''
        }

        const facilityClosedSettingInfo: CustomFacilityClosedSettingInfo[] = this.state.facilityClosedSettingInfo
        facilityClosedSettingInfo[facilityIndex].closedSettingInfo[closedSettingFacilityIndex].startTimeMinute =
            startTimeMinute

        this.setState({
            facilityClosedSettingInfo: facilityClosedSettingInfo,
        })
    }

    changeEndDate(facilityIndex: number,
                  closedSettingFacilityIndex: number,
                  date: Nullable<Date>): void {
        const facilityClosedSettingInfo: CustomFacilityClosedSettingInfo[] = this.state.facilityClosedSettingInfo
        if (date !== null) {
            facilityClosedSettingInfo[facilityIndex].closedSettingInfo[closedSettingFacilityIndex].endDate =
                date.toString()
        } else {
            facilityClosedSettingInfo[facilityIndex].closedSettingInfo[closedSettingFacilityIndex].endDate = ''
        }

        this.setState({
            facilityClosedSettingInfo: facilityClosedSettingInfo,
        })
    }

    changeEndTimeHour(
        facilityIndex: number,
        closedSettingFacilityIndex: number,
        event: SelectChangeEvent<unknown>,
    ): void {
        let endTimeHour: string = ''
        try {
            const codeMaster = HOURS_24.codeToEnumConstants(event.target.value as string)
            if (codeMaster) {
                endTimeHour = event.target.value as string
            }
        } catch (e) {
            endTimeHour = ''
        }

        const facilityClosedSettingInfo: CustomFacilityClosedSettingInfo[] = this.state.facilityClosedSettingInfo
        facilityClosedSettingInfo[facilityIndex].closedSettingInfo[closedSettingFacilityIndex].endTimeHour =
            endTimeHour

        this.setState({
            facilityClosedSettingInfo: facilityClosedSettingInfo,
        })
    }

    changeEndTimeMinute(
        facilityIndex: number,
        closedSettingFacilityIndex: number,
        event: SelectChangeEvent<unknown>,
    ): void {
        let endTimeMinute: string = ''
        try {
            const codeMaster = RESERVATION_TIME_UNIT_MINUTES.codeToEnumConstants(event.target.value as string)
            if (codeMaster) {
                endTimeMinute = event.target.value as string
            }
        } catch (e) {
            endTimeMinute = ''
        }

        const facilityClosedSettingInfo: CustomFacilityClosedSettingInfo[] = this.state.facilityClosedSettingInfo
        facilityClosedSettingInfo[facilityIndex].closedSettingInfo[closedSettingFacilityIndex].endTimeMinute =
            endTimeMinute

        this.setState({
            facilityClosedSettingInfo: facilityClosedSettingInfo,
        })
    }

    changeClosedReason(
        facilityIndex: number,
        closedSettingFacilityIndex: number,
        event: React.ChangeEvent<HTMLInputElement>,
    ): void {
        const facilityClosedSettingInfo: CustomFacilityClosedSettingInfo[] = this.state.facilityClosedSettingInfo
        facilityClosedSettingInfo[facilityIndex].closedSettingInfo[closedSettingFacilityIndex].closedReason =
            event.target.value

        this.setState({
            facilityClosedSettingInfo: facilityClosedSettingInfo,
        })
    }

    // 休館設定 Styleチェック
    judgeClosedSetting(
        type: Process,
        facilityIndex: number,
        closedIndex: number,
        originFacilityIndex: number,
        originClosedSettingIndex: number,
        field: Field,
    ): boolean {

        const closedSettingInfo: CustomClosedSettingInfo =
            this.state.facilityClosedSettingInfo[facilityIndex].closedSettingInfo[closedIndex]
        const originClosedSettingInfo: CustomClosedSettingInfo =
            this.originFacilityClosedSettingInfo[originFacilityIndex].closedSettingInfo[originClosedSettingIndex]

        // 休館設定 更新
        if (type === 'update') {
            let target: string = ''
            let origin: string = ''

            if (closedSettingInfo && originClosedSettingInfo) {
                switch (field) {
                    case 'startDate':
                        target = closedSettingInfo.startDate
                        origin = originClosedSettingInfo.startDate
                        break
                    case 'startTimeHour':
                        target = closedSettingInfo.startTimeHour
                        origin = originClosedSettingInfo.startTimeHour
                        break
                    case 'startTimeMinute':
                        target = closedSettingInfo.startTimeMinute
                        origin = originClosedSettingInfo.startTimeMinute
                        break
                    case 'endDate':
                        target = closedSettingInfo.endDate
                        origin = originClosedSettingInfo.endDate
                        break
                    case 'endTimeHour':
                        target = closedSettingInfo.endTimeHour
                        origin = originClosedSettingInfo.endTimeHour
                        break
                    case 'endTimeMinute':
                        target = closedSettingInfo.endTimeMinute
                        origin = originClosedSettingInfo.endTimeMinute
                        break
                    case 'closedReason':
                        target = closedSettingInfo.closedReason
                        origin = originClosedSettingInfo.closedReason
                        break
                    default:
                        return false
                }
                return target !== origin
            } else {
                return false
            }
        } else {
            // 休館設定　登録
            return (
                closedSettingInfo.startDate !== '' ||
                closedSettingInfo.startTimeHour !== '' ||
                closedSettingInfo.startTimeMinute !== '' ||
                closedSettingInfo.endDate !== '' ||
                closedSettingInfo.endTimeHour !== '' ||
                closedSettingInfo.endTimeMinute !== '' ||
                closedSettingInfo.closedReason !== ''
            )
        }
    }

    async registerClosedSettingButton(): Promise<void> {

        await this.props.eventEmitter.showDialog({
                title: '確認',
                errorLevel: Messages.IOPCC0012.errorLevel,
                message: Messages.IOPCC0012.toString('施設の休館設定'),
                buttonProps: [
                    {
                        isDefault: false,
                        buttonLabel: 'キャンセル',
                        buttonHandler: this.handleRegisterCancelClick,
                    },
                    {
                        isDefault: false,
                        buttonLabel: 'OK',
                        buttonHandler: this.handleRegisterOkClick,
                    },
                ],
            },
        )
    }


    handleRegisterCancelClick(): void {
        this.props.eventEmitter.closeDialog()
    }

    async handleRegisterOkClick(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        this.props.eventEmitter.closeDialog()
        try {
            // 休館設定一括反映
            const closedSettingParam: NatPostClosedSettingParams = this.createPostClosedSettingParams()
            const registerClosedSettingResponse: Nullable<NatPostClosedSetting> = await this.props.asyncCallFunction(
                this.props.closedSettingRepo.postClosedSetting.bind(this.props.closedSettingRepo, closedSettingParam),
                async (httpErrorOrNetworkError) => {
                    await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                },
                {defaultErrorTitle: Messages.EOPCR0006.toString('休館')},
            )

            if (!registerClosedSettingResponse || registerClosedSettingResponse.requestError) {
                return
            }

            if (registerClosedSettingResponse.informations &&
                registerClosedSettingResponse.informations.length > 0 &&
                registerClosedSettingResponse.informations.some(info => info.type === MESSAGE_TYPE.WARNING.value)) {

                this.setState({dialogStatus: 'registerCloseSettings'})
            } else {
                this.props.navigate(this.props.location.pathname, {
                    state: {
                        registerCompleteType: 'registerClosedSettings',
                    },
                })
                window.location.reload()
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    async handleOkClickDialogForRegisterClosedSettings(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        this.props.eventEmitter.closeDialog()
        try {
            // 休館設定一括反映
            const closedSettingParam: NatPostClosedSettingParams = this.createPostClosedSettingParams()
            await this.props.asyncCallFunction(
                this.props.closedSettingRepo.registerClosedSetting.bind(
                    this.props.closedSettingRepo, closedSettingParam,
                ),
                async (httpErrorOrNetworkError) => {
                    await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                },
                {defaultErrorTitle: Messages.EOPCR0006.toString('休館')},
            )

            const closedPeriods: ClosedPeriod[] = await this.getClosedPeriods(closedSettingParam)
            const currentDateTimeResponse: Nullable<NatGetCurrentDateTime> = await this.props.asyncCallFunction(
                this.props.currentDateTimeRepo.getCurrentDateTime.bind(this.props.currentDateTimeRepo),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )
            let currentDateTime: Nullable<Moment> = null
            if (currentDateTimeResponse && currentDateTimeResponse.details) {
                currentDateTime = moment(currentDateTimeResponse.details.currentDateTime)
            }

            this.setState({
                dialogStatus: 'cancelReservations',
                currentDateTime: currentDateTime,
                closedPeriods: closedPeriods,
                closedSettingParam: closedSettingParam,
            })

        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    async getFacilityReservations(closeSetting: RegisterClosedSetting | UpdateClosedSetting): Promise<ClosedPeriod> {
        const response: Nullable<ReservationsByClosedPeriod[]> = await this.props.asyncCallFunction(
            this.props.facilityReserveRepo.getFacilityReservationsByClosedPeriod.bind(
                this.props.facilityReserveRepo,
                closeSetting,
            ),
            async (httpErrorOrNetworkError) => {
                await this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
            },
        )

        const facility = this.originFacilityClosedSettingInfo
            .find(f => f.facilityId === closeSetting.facilityId)

        const endDate = convertToMoment(closeSetting.endDate, null)
        endDate.add(closeSetting.endTimeHour, 'hours')
        endDate.add(closeSetting.endTimeMinute, 'minutes')
        return {
            facilityId: closeSetting.facilityId,
            facilityName: facility ? facility.facilityName : '',
            startDateTime: fromDateAndTimeToMoment(
                closeSetting.startDate,
                closeSetting.startTimeHour,
                closeSetting.startTimeMinute,
            ),
            endDateTime: endDate,
            reservationList: response ? response : [],
        }
    }

    async getClosedPeriods(closedSettingParam: NatPostClosedSettingParams): Promise<ClosedPeriod[]> {
        const {registerClosedSetting, updateClosedSetting} = closedSettingParam
        const closedPeriods: ClosedPeriod[] = []
        for (const closedSetting of registerClosedSetting) {
            const closedPeriod = await this.getFacilityReservations(closedSetting)
            if (closedPeriod !== null) {
                closedPeriods.push(closedPeriod)
            }
        }
        for (const closedSetting of updateClosedSetting) {
            const closedPeriod: Nullable<ClosedPeriod> = await this.getFacilityReservations(closedSetting)
            if (closedPeriod !== null) {
                closedPeriods.push(closedPeriod)
            }
        }
        return closedPeriods
    }

    createPostClosedSettingParams(): NatPostClosedSettingParams {
        const facilityClosedSettingInfo: CustomFacilityClosedSettingInfo[] =
            this.state.facilityClosedSettingInfo
        const originFacilityClosedSettingInfo: CustomFacilityClosedSettingInfo[] =
            this.originFacilityClosedSettingInfo
        const registerClosedSetting: RegisterClosedSetting[] = []
        const updateClosedSetting: UpdateClosedSetting[] = []

        // リクエスト生成
        for (let i: number = 0; i < Object.keys(facilityClosedSettingInfo).length; i++) {
            const targetFacilityId: string = facilityClosedSettingInfo[i].facilityId

            // 対象施設
            const targetFacilityClosedSetting =
                originFacilityClosedSettingInfo.filter(tmpFacilityClosedSettingInfo => {
                    if (tmpFacilityClosedSettingInfo.facilityId === targetFacilityId) {
                        return tmpFacilityClosedSettingInfo.closedSettingInfo
                    }
                })

            for (let j: number = 0; j < Object.keys(facilityClosedSettingInfo[i].closedSettingInfo).length; j++) {
                const targetSeq: number = facilityClosedSettingInfo[i].closedSettingInfo[j].seq

                // 対象休館設定
                const targetClosedSettingInfo =
                    targetFacilityClosedSetting[0].closedSettingInfo.filter(tmpClosedSettingInfo => {
                        if (tmpClosedSettingInfo.seq === targetSeq) {
                            return tmpClosedSettingInfo
                        }
                    })

                // 休館設定登録
                if (
                    facilityClosedSettingInfo[i].closedSettingInfo[j].type === 'register' && (
                        facilityClosedSettingInfo[i].closedSettingInfo[j].startDate !== '' ||
                        facilityClosedSettingInfo[i].closedSettingInfo[j].startTimeHour !== '' ||
                        facilityClosedSettingInfo[i].closedSettingInfo[j].startTimeMinute !== '' ||
                        facilityClosedSettingInfo[i].closedSettingInfo[j].endDate !== '' ||
                        facilityClosedSettingInfo[i].closedSettingInfo[j].endTimeHour !== '' ||
                        facilityClosedSettingInfo[i].closedSettingInfo[j].endTimeMinute !== '' ||
                        facilityClosedSettingInfo[i].closedSettingInfo[j].closedReason !== ''
                    )
                ) {
                    const registerData: RegisterClosedSetting = {
                        facilityId: facilityClosedSettingInfo[i].facilityId,
                        seqWork: facilityClosedSettingInfo[i].closedSettingInfo[j].seq,
                        startDate: (facilityClosedSettingInfo[i].closedSettingInfo[j].startDate !== '') ?
                            formatForDateInput(facilityClosedSettingInfo[i].closedSettingInfo[j].startDate) : '',
                        startTimeHour: facilityClosedSettingInfo[i].closedSettingInfo[j].startTimeHour,
                        startTimeMinute: facilityClosedSettingInfo[i].closedSettingInfo[j].startTimeMinute,
                        endDate: (facilityClosedSettingInfo[i].closedSettingInfo[j].endDate !== '') ?
                            formatForDateInput(facilityClosedSettingInfo[i].closedSettingInfo[j].endDate) : '',
                        endTimeHour: facilityClosedSettingInfo[i].closedSettingInfo[j].endTimeHour,
                        endTimeMinute: facilityClosedSettingInfo[i].closedSettingInfo[j].endTimeMinute,
                        closedReason: facilityClosedSettingInfo[i].closedSettingInfo[j].closedReason,
                    }
                    registerClosedSetting.push(registerData)
                } else if (facilityClosedSettingInfo[i].closedSettingInfo[j].type === 'update') {
                    // 休館設定更新
                    const jsonClosedSettingInfo: string =
                        JSON.stringify(facilityClosedSettingInfo[i].closedSettingInfo[j])
                    const jsonOriginClosedSettingInfo: string =
                        JSON.stringify(targetClosedSettingInfo[0])

                    if (jsonClosedSettingInfo !== jsonOriginClosedSettingInfo) {
                        const updateData: UpdateClosedSetting = {
                            facilityId: facilityClosedSettingInfo[i].facilityId,
                            seq: facilityClosedSettingInfo[i].closedSettingInfo[j].seq,
                            startDate: (facilityClosedSettingInfo[i].closedSettingInfo[j].startDate !== '') ?
                                formatForDateInput(facilityClosedSettingInfo[i].closedSettingInfo[j].startDate) : '',
                            startTimeHour: facilityClosedSettingInfo[i].closedSettingInfo[j].startTimeHour,
                            startTimeMinute: facilityClosedSettingInfo[i].closedSettingInfo[j].startTimeMinute,
                            endDate: (facilityClosedSettingInfo[i].closedSettingInfo[j].endDate !== '') ?
                                formatForDateInput(facilityClosedSettingInfo[i].closedSettingInfo[j].endDate) : '',
                            endTimeHour: facilityClosedSettingInfo[i].closedSettingInfo[j].endTimeHour,
                            endTimeMinute: facilityClosedSettingInfo[i].closedSettingInfo[j].endTimeMinute,
                            closedReason: facilityClosedSettingInfo[i].closedSettingInfo[j].closedReason,
                        }
                        updateClosedSetting.push(updateData)
                    }
                }
            }
        }
        // 休館設定一括反映
        return {
            registerClosedSetting: registerClosedSetting,
            updateClosedSetting: updateClosedSetting,
            deleteClosedSetting: this.state.deleteClosedSetting,
        }
    }

    renderPageFooterArea(): ReactNode {
        return (<>
            <PageFotterAreaRight>
                <AdminPrimaryButton onClick={this.registerClosedSettingButton}>
                    登録
                </AdminPrimaryButton>
            </PageFotterAreaRight>
            <PageFotterAreaLeft>
                <BackLink onClick={(event: React.MouseEvent) => {
                    event.preventDefault()
                    this.cancelLinkClick()
                }}>
                    キャンセル
                </BackLink>
            </PageFotterAreaLeft>
        </>)
    }

    renderRegisterDialog(): ReactNode {
        const {dialogStatus} = this.state
        if (dialogStatus === null) {
            return null
        }

        if (dialogStatus === 'registerCloseSettings') {
            return <>
                <Dialog
                    id={'pp-dialog'}
                    open={dialogStatus === 'registerCloseSettings'}
                    transitionDuration={(process.env.NODE_ENV === 'test') ? 0 : undefined}
                    maxWidth={'md'}
                >
                    {this.renderDialogForRegisterClosedSettings()}
                </Dialog>
            </>
        }

        if (dialogStatus === 'cancelReservations') {
            return <>
                <Dialog
                    id={'pp-dialog'}
                    open={dialogStatus === 'cancelReservations'}
                    transitionDuration={(process.env.NODE_ENV === 'test') ? 0 : undefined}
                    maxWidth={'md'}
                    fullWidth={true}
                >
                    {this.renderDialogForCancelReserveList()}
                </Dialog>
            </>
        }
    }

    renderDialogForRegisterClosedSettings(): ReactNode {
        return <>
            <DialogTitle id="alert-dialog-title">
                <LeftRowFlexContainer>
                    {createIconWithLevel(MESSAGE_TYPE.WARNING)}確認
                </LeftRowFlexContainer>
            </DialogTitle>
            <DialogContent>
                <StyledDialogContentText>
                    指定した休館期間にはすでに予約が入っています。
                    <br/>休館設定を登録しますか？
                </StyledDialogContentText>
            </DialogContent>
            <DialogActions>
                <PageFooterArea>
                    <BackLink onClick={this.handleCancelClickDialogForRegisterClosedSettings}>
                        設定画面に戻る
                    </BackLink>
                    <AdminPrimaryButton onClick={this.handleOkClickDialogForRegisterClosedSettings}>
                        休館設定を登録
                    </AdminPrimaryButton>
                </PageFooterArea>
            </DialogActions>
        </>
    }

    renderDialogForCancelReserveList(): ReactNode {
        const {currentDateTime, closedPeriods, closedSettingParam} = this.state
        if (currentDateTime === null || closedPeriods === null || closedSettingParam === null) {
            return null
        }

        return <CancelReservationsForm
            facilityReserveRepo={this.props.facilityReserveRepo}
            personalInfoExtractHistoryRepo={this.props.personalInfoExtractHistoryRepo}
            currentDateTime={currentDateTime}
            closedPeriods={closedPeriods}
            closedSettingParam={closedSettingParam}
            eventEmitter={this.props.eventEmitter}
            onCancelReservationClick={this.handleOkClickDialogForCancelReservations}
            onCloseButtonClick={this.handleCloseClickDialogForCancelReservations}
            onDownloadClick={this.handleDownloadCSV}
            asyncCallFunction={this.props.asyncCallFunction}
        />
    }

    handleCancelClickDialogForRegisterClosedSettings(): void {
        this.setState({dialogStatus: null})
    }

    handleCloseClickDialogForCancelReservations(): void {
        this.setState({dialogStatus: null})
        this.props.navigate(this.props.location.pathname, {
            state: {
                registerCompleteType: 'registerClosedSettings',
            },
        })
        window.location.reload()
    }

    handleDownloadCSV(closedPeriods: ClosedPeriod[]): void {
        const {currentDateTime} = this.state
        if (currentDateTime === null) {
            return
        }

        const CSV_HEADERS = [
            '休館施設名',
            '休館開始日時',
            '休館終了日時',
            '利用者棟名',
            '利用者部屋番号',
            '利用者氏名（姓）',
            '利用者氏名（名）',
            '予約開始日時',
            '予約終了日時',
            '過去予約',
        ]

        const reservationList: string[][] = closedPeriods.flatMap(period => {
            return period.reservationList.map(reservation => {
                return [
                    this.escapeCSV(period.facilityName),
                    formatDateTimeLocal(period.startDateTime),
                    formatDateTimeLocal(period.endDateTime),
                    this.escapeCSV(reservation.userRidgeName),
                    this.escapeCSV(reservation.userRoomNumber),
                    this.escapeCSV(reservation.userFamilyName),
                    this.escapeCSV(reservation.userFirstName),
                    formatDateTimeLocal(reservation.startDateTime),
                    formatDateTimeLocal(reservation.endDateTime),
                    reservation.startDateTime.isBefore(currentDateTime) ? '過去の予約です' : '',
                ]
            })
        })

        const csv: string = [CSV_HEADERS, ...reservationList]
            .map(record => record.join(','))
            .join('\n')
        const condominiumCd = SessionStorageHelper.getStringItemOrNull('selectedCondominiumCd')
        const condominiumName = SessionStorageHelper.getStringItemOrNull('selectedCondominiumName')
        const fileName = condominiumCd + '_' + condominiumName + '_キャンセルリスト_' + formatDateLocal(currentDateTime) + '.csv'

        if (isIE) {
            this.msDownloadCSV(csv, fileName)
        } else {
            this.downloadCSV(csv, fileName)
        }
    }

    escapeCSV(str: Nullable<string>): string {
        if (str === null) {
            return '""'
        }
        return '"' + str.replace(/"/, '”') + '"'
    }

    msDownloadCSV(data: string, fileName: string): void {
        const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
        if (window.navigator.msSaveBlob) {
            const blob = new Blob([bom, data], {type: 'text/csv'})
            window.navigator.msSaveBlob(blob, fileName)
        }
    }

    downloadCSV(data: string, fileName: string): void {
        const anchor = document.createElement('a')
        const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
        if (window.URL && anchor.download !== undefined) {
            const blob = new Blob([bom, data], {type: 'text/csv'})
            anchor.download = fileName

            anchor.href = window.URL.createObjectURL(blob)

            document.body.appendChild(anchor)
            anchor.click()
            if (anchor.parentNode) {
                anchor.parentNode.removeChild(anchor)
            }
        }
    }


    handleOkClickDialogForCancelReservations(): void {
        this.setState({dialogStatus: null})
        this.props.navigate(this.props.location.pathname, {
            state: {
                registerCompleteType: 'cancelReservations',
            },
        })
        window.location.reload()
    }

    renderPage(): Nullable<ReactElement> {
        if (this.state.facilityClosedSettingInfo.length === 0) {
            return (<>
                {Messages.IOPCC0015.toString('施設')}
            </>)
        } else if (
            judgeAuthorityCheck(HKConstants.CMN.AUTH.VIEW_FACILITY_CLOSED_SETTING) &&
            !judgeAuthorityCheck(HKConstants.CMN.AUTH.EDIT_FACILITY_CLOSED_SETTING) &&
            this.state.facilityClosedSettingInfo[0].closedSettingInfo.length === 0
        ) {
            return (<>
                {Messages.IOPCC0015.toString('施設の休館設定')}
            </>)
        } else {
            return (<>
                <PageMainArea>
                    {this.renderClosedSettingTable(this.state.facilityClosedSettingInfo)}
                    {this.renderRegisterDialog()}
                </PageMainArea>
                <PageFooterArea>
                    {this.renderPageFooterArea()}
                </PageFooterArea>
            </>)
        }
    }

    render(): ReactNode {
        if (!this.state.isLoadCompleted) {
            return null
        }
        return (
            <form>
                {this.renderPage()}
            </form>
        )
    }
}

export default createAdminPage(NatAdminClosedSettingPage)


// 入力フォームProps
interface WrapperInputFormProps {
    changeFlg?: Nullable<boolean>;
}

const FromToLabel: StyledLabel = styled.label`
  margin: 0 5px 0 5px;
`

const WrapperViewClosedSetting: StyledDiv = styled.div`
  margin: 0 auto;
  text-align: center;
`

const ViewClosedSettingText: StyledP = styled.p`
  display: inline-block;
  text-align: left;
`

const TermFlexContainer: StyledDiv = styled.div`
  display: flex;
  flex: 1 1 0%;
  flex-direction: column;
  width: 100%;
`

const ClosedReasonFlexContainer: StyledDiv = styled.div`
  display: flex;
  flex: 1 1 0%;
  flex-direction: column;
  width: 100%;
  padding-left: 15px;
  padding-right: 15px;
`

const WrapperInputForm = styled.div<WrapperInputFormProps>`
  display: flex;
  flex: 1 1 auto;
  justify-items: center;
  align-items: center;

  ${props => props.changeFlg === true ? `  & div,select {
    background-color:#ffe0b2;
  }}` : ``};
`

const PaddingRightTxt: StyledSpan = styled.span`
  padding-right: 15px;
`

const StyledSortablePaginationTableBody = styled(({viewFlg, ...props}) => (
    <SortablePaginationTableBody {...props} />
))<TableBodyProps & { viewFlg?: boolean }>`
  ${props => props.viewFlg === true ? ` &.MuiTableBody-root {
      background-color: #bdbdbd;
   }` : ``};
`

const FacilityTableCell = styled(TableCell)`
  &.MuiTableCell-root {
    width: 12%;
    word-break: break-all;
  }
`

const StyledTableCell = styled(TableCell)`
  &.MuiTableCell-root {
    padding: 14px 0 14px 0;
  }
`

const FlexBasis: StyledDiv = styled.div`
  flex: 1 1 0%;
`

const StyledDialogContentText = styled(DialogContentText)`
    &.MuiDialogContentText-root {
        color: rgba(0, 0, 0, 0.87);
    }
`
